<template>
  <f7-page id="faq-page" name="faq-page" @page:afterin="afterin">
  <f7-navbar class="no-border view-mobile">
      <div class="navbar-inner">
        <f7-nav-left class="back-button">
          <f7-link @click="goBack()" class="customBack" color="black"><i class="f7-icons">chevron_left</i></f7-link>
        </f7-nav-left>
        <f7-nav-right></f7-nav-right>
      </div>
    </f7-navbar>
    <f7-block>
        <div class="col-70 text-center fw-bold mb-xl wandr-title-1">{{$t('general-text-faq')}}</div>

        <div class="list accordion-list" id="faq">
            <f7-searchbar search-container=".faq-list" search-in=".item-title" :placeholder="$t('general-text-search')" id="faq-search-bar"></f7-searchbar>

            <f7-list id="searchbar-not-found" class="searchbar-not-found">
              <f7-list-item :title="$t('general-text-nothing-found')"></f7-list-item>
            </f7-list>

            <ul class="faq-list mt-md">
              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-getting-started')}}</div>
              <li class="accordion-item" id="getting_started-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Who is Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Wandr-E, a brand of Wandr Pte Ltd and a licensed major payments institution regulated by the Monetary Authority of Singapore (MAS), offers a simple, affordable, and accessible platform to transfer funds globally at competitive exchange rates. Whether you need to pay bills or send money to loved ones, we are here to help you with all your fund transfer needs. <br><br> We will refer to our business as Wandr-E in these FAQs. You can learn more about our business in the <a class="faq-anchor" href="#" @click="followLink('mkt','aboutus')"><b>'About Us'</b></a> section.</p></div>
              </li>

              <li class="accordion-item" id="getting_started-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Who is eligible to use the services Wandr-E provides?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>You must be at least 18 years old and possess a valid government-issued photo identification documentation such as a Singapore Identity Card, Permanent Resident Identity Card, Employment Pass, S Pass, Work Permit, or other equivalent documents for residing in Singapore.</p></div>
              </li>

              <li class="accordion-item" id="getting_started-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Where can I download the Wandr-E mobile application?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>You can download the Wandr-E mobile application either through the Apple App Store or Google Play Store. Alternatively, you can download the Wandr-E mobile application by scanning the QR code below.</p>
                  <div class="d-flex justify-content-center align-items-center">
                    <div><img :src="require('@/assets/img/mobile-app-download-qr.png')" width="120px" height="120px" /></div>
                    <div class="ms-2">
                      <a href="#" class="d-block" @click="followLink('downloadapp', 'appstore')"><img :src="require('@/assets/img/icon/download-apple-store.svg')" style=""/></a>
                      <a href="#" class="d-block" @click="followLink('downloadapp', 'playstore')"><img :src="require('@/assets/img/icon/download-google-play.svg')" style=""/></a>
                    </div>
                  </div>
                </div>
              </li>

              <li class="accordion-item" id="getting_started-4">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What permissions do I need to enable on the Wandr-E mobile application to enjoy the full suite of services available?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>To access the full suite of services, you will need to grant permission to the Wandr-E mobile application to access your device's camera, gallery, and biometric data. The camera access is required for you to take photos of your identification documents for the identity confirmation process (if you choose to register through a non Singpass MyInfo method) and gallery is required if you choose to upload your identification documents from your device's photo gallery.</p>
                  <p>For the best experience, it is highly recommended that you enable push notifications on the Wandr-E mobile application. These notifications will keep you informed on the status of your fund transfer and any ongoing deals or promotions offered by Wandr-E.</p>
                </div>
              </li>

              <li class="accordion-item" id="getting_started-5">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How can I access Wandr-E's online platform?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>You can access Wandr-E's online platform by visiting <a href="#" @click="followLink('mkt')">www.wandr-e.com</a>.</p></div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-registration-verification')}}</div>
              <li class="accordion-item" id="register_verify-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I register to become a Wandr-E customer?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>You can register for Wandr-E's services either through our mobile application or online platform at <a href="#" @click="followLink('mkt')">www.wandr-e.com</a>. If you wish to register through the mobile application, simply download it from either the <a href="#" @click="followLink('downloadapp', 'appstore')"><b>Apple App Store</b></a> or <a href="#" @click="followLink('downloadapp', 'playstore')"><b>Google Play Store</b></a>. <br><br>There are four methods for registering as a Wandr-E customer.</p>
                  
                  <ol class="faq-content-list">
                    <li class="mt-xl searchbar-ignore" v-for="item in registrationSteps" :key="item.id">
                      <div>{{item.title}}</div>
                      <ol class="faq-content-list">
                        <li v-for="it in item.steps" class="searchbar-ignore" :key="it" v-html="it"></li>
                      </ol>
                      <p>{{item.desc}}</p>
                    </li>
                  </ol>
                </div>
              </li>

              <li class="accordion-item" id="register_verify-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What forms of identification and other documents can I submit for identity confirmation?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>You can confirm your identity through Singpass MyInfo, or you can submit any of the listed identification documents (as mentioned in Table 1) as an alternative.</p>
                  <p>Please note that you will need to provide an additional document to prove your residence if your residential address is not displayed on Singpass MyInfo or in your identification document. Any of the documents in Table 2 is acceptable.</p>
                  <p>Your address document must include your name as it appears on your Wandr-E account, the date of issue (which must be within the past 3 months), and the name/logo of the issuer.</p>
                  <div>
                    <p>Table 1: List of Approved Identification Documents</p>
                    <table class="faq-table fs-12">
                      <tbody>
                        <tr>
                          <td >Singaporean / Permanent Resident</td>
                          <td >NRIC</td>
                        </tr>
                        <tr>
                          <td >National Servicemen and Regulars</td>
                          <td >SAF 11B, SPF 11B, or SCDF 18</td>
                        </tr>
                        <tr>
                          <td >Foreigners</td>
                          <td >A valid Singapore government-issued photo identification document on the day of registration.
                            <br><br>Valid passes include: Employment Pass, EntrePass, S Pass, Work Permit (all types), Training Employment Pass, Dependent Pass, Long Term Visit Pass, and Student Pass.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <p class="mt-3">Table 2: List of Approved Address documents</p>
                    <table class="faq-table fs-12">
                      <tbody>
                        <tr>
                          <td >Bank Statement</td>
                        </tr>
                        <tr>
                          <td >Utility or Telecommunication Bill</td>
                        </tr>
                        <tr>
                          <td >Correspondence/Letter from local government agencies</td>
                        </tr>
                        <tr>
                          <td >Valid lease or accommodation agreement</td>
                        </tr>
                        <tr>
                          <td >Company registration document (ACRA)</td>
                        </tr>
                        <tr>
                          <td >Insurance correspondence</td>
                        </tr>
                      </tbody>
                    </table>
                    <p>If you do not have any of the required documents, you can contact our Customer Service Team at <a href="#" @click="followLink('email', 'customerservice@wandr-e.com')">customerservice@wandr-e.com</a> for assistance.</p>
                  </div>
                </div>
              </li>

              <li class="accordion-item" id="register_verify-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How long does it take to confirm my identity?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>You can register with Singpass MyInfo and instantly confirm your identity if your residential address is already available in Singpass MyInfo. If you have submitted your identification and/or address documents through our mobile application or online platform, the confirmation process may take up to one day.</p></div>
              </li>

              <li class="accordion-item" id="register_verify-4">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Do I need to confirm my identity each time I use Wandr-E's services?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>No. However, if your identification document has an expiration date, you must update your identification information through Singpass MyInfo or by submitting manually once the current one has expired. Go to 'Account', then select 'My Details' and 'Upload Identification Documents' to upload a new identification document on the mobile application or online platform.</p></div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-account-access')}}</div>

              <li class="accordion-item" id="account_access-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Do I need an active connection to access my account?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Yes, in order to access and log in to your Wandr-E account via the mobile application or online platform, you will need a WiFi, 3G, 4G, or 5G internet connection.</p></div>
              </li>

              <li class="accordion-item" id="account_access-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Is the Wandr-E mobile application and online platform accessible 24 hours?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Yes, our digital facilities are accessible every day of the week, 24 hours a day. You can initiate an overseas fund transfer at any time and from anywhere. Please note that while you can initiate a fund transfer through our digital channels outside of business hours, the transfer will only be processed after payment has been received into Wandr-E's designated customer's account and is subject to our service processing time. <br><br>Our DBS customer's bank (current) account number is 0019066433.</p></div>
              </li>

              <li class="accordion-item" id="account_access-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I create a password for my Wandr-E account?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>You will be required to create a password as part of the registration process. This password is used to log in to both the Wandr-E mobile application and the online platform.</p></div>
              </li>

              <li class="accordion-item" id="account_access-4">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I access my Wandr-E account?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>There are 4 ways for you to access your account on the Wandr-E mobile application and online platform.</p>
                  <ol class="faq-content-list">
                    <li class="mt-xl searchbar-ignore" v-for="item in loginSteps" :key="item.id">
                      <div>{{item.title}}</div>
                      <ol class="faq-content-list" type="i">
                        <li v-for="it in item.steps" class="searchbar-ignore" :key="it">{{it}}</li>
                      </ol>
                    </li>
                  </ol>
                </div>
              </li>

              <li class="accordion-item" id="account_access-5">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I update my mobile number with Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>To update the registered mobile number associated with your Wandr-E account, log in and select 'Account' from the main menu, then choose 'My Details'. Select 'Edit', then enter both your current and new mobile numbers. You must enter your account password and the 6-digit One-Time-Password (OTP) that was sent to your mobile number to confirm the update.</p></div>
              </li>

              <li class="accordion-item" id="account_access-6">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I update my email address with Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>To update the registered email address associated with your Wandr-E account, simply log in and access the ‘Account’ section through the main menu and from there, proceed to ‘Details’. In the Email field, select ‘Edit’, then enter your new email address. To finalise the change, you will need to enter your account password and click the verification link sent to your new email address. Your updated email address will be linked to your Wandr-E account once you have successfully verified the new email.</p></div>
              </li>

              <li class="accordion-item" id="account_access-7">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Will my account be locked if I log in with the incorrect login details?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Yes, your account will be temporarily locked if you have entered the incorrect login information for three consecutive times. This is a security measure to safeguard your account. You can try logging in again after 15 minutes.<br><br> If you are still having trouble accessing your account, please email our Customer Service Team at <a href="#" @click="followLink('email', 'customerservice@wandr-e.com')">customerservice@wandr-e.com</a>, between 9am to 7pm on Mondays through Fridays (excluding public holidays).</p></div>
              </li>

              <li class="accordion-item" id="account_access-8">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What should I do if I haven't received my One-Time-Password (OTP)?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>Wandr-E uses third-party telecommunications providers for its SMS notification services. If you did not receive your One-Time Password (OTP), you can request a new one by selecting the 'Resend Now' button.</p>
                  <p>If you have tried requesting a new OTP without success, the issue may be due to an outdated mobile number in our records or an issue with your SMS provider. In order to resolve this, please confirm the accuracy of the mobile number registered with Wandr-E or get in touch with your SMS provider to see if they are experiencing any issues.</p>
                  <p>Find instructions on how to update your mobile number <a href="#" @click="scrollToRef(`account_access-5`)">here</a>.</p>
                </div>
              </li>

              <li class="accordion-item" id="account_access-9">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What happens to my Wandr-E mobile application when I change my mobile phone?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>If your mobile number has not changed, you can install the Wandr-E mobile application on your new phone, tap on 'Login', and select your preferred login method. To complete the login process, follow the steps and enter the 6-digit One-Time-Password (OTP) that was sent to your registered mobile number.<br><br> If you have changed your mobile number, please email our Customer Service Team at <a href="#" @click="followLink('email', 'customerservice@wandr-e.com')">customerservice@wandr-e.com</a>, between 9am to 7pm on Mondays through Fridays (excluding public holidays).</p></div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-service-payment')}}</div>

              <li class="accordion-item" id="service_payment-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Which countries can I transfer funds from using Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>At the moment, customers of Wandr-E can only transfer funds out of Singapore. Do check back for updates!</p></div>
              </li>

              <li class="accordion-item" id="service_payment-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Which countries can I transfer funds to using Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>You can transfer funds to the following countries:</p>
                  <ul class="faq-content-list">
                    <li class="searchbar-ignore" v-for="item in transferCountries" :key="item.id">
                      <b>{{item.title}}</b>{{item.content}}
                    </li>
                  </ul>
                  <p>We provide fund transfer services to numerous countries. If the country to which you wish to send funds to is not listed, please email us at <a href="#" @click="followLink('email', 'customerservice@wandr-e.com')">customerservice@wandr-e.com</a> so that we can assist you.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I start transferring funds through Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>Once your account has been confirmed, you may add a recipient by selecting 'Recipients' from the main menu before initiating transfers by selecting the 'Send' button.</p>
                  <p>Learn how to add a recipient <a href="#" @click="scrollToRef(`service_payment-7`)">here</a>.</p><p>Learn how to create a fund transfer <a href="#" @click="scrollToRef(`service_payment-9`)">here</a>.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-4">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What is the purpose of the 'Quick Send' feature?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>The 'Quick Send' feature enables you to quickly create a fund transfer without beginning from scratch by displaying your top five recipients. It also displays the remittance amount, the purpose for the payment, and your preferred payment method based on your most recent transfer to the recipient. You can choose to change the transfer information before selecting 'Next' to create the fund transfer.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-5">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">Are there any limits on how much I can transfer?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>Yes, transfers made through the Wandr-E mobile application or online platform have a minimum transfer amount of SGD 5 and a maximum transfer amount of SGD 25,000 per transaction. Preferential exchange rates are available for transfers above SGD 25,000. For further information, please email our Premier Desk at <a href="#" @click="followLink('email', 'premier@wandr-e.com')">premier@wandr-e.com</a>.</p></div>
              </li>

              <li class="accordion-item" id="service_payment-6">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What delivery service options are available and how long will my overseas transfers take?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>We provide a number of delivery service options, such as bank account transfers, cash collection, and bill payment. The availability of these services varies depending on the country of destination.</p>
                  <p>Description of delivery service:</p>
                  <ul class="faq-content-list list-bullet">
                    <li class="searchbar-ignore" v-for="item in deliveryMethods" :key="item.id">
                      {{item}}
                    </li>
                  </ul>
                  <p>The fund transfer process will commence once Wandr-E receives the payment. The estimated service time shown below assumes that the payment has been received before the payment cut-off period (if applicable) and that there are no delays from any parties involved.</p>
                  <p><b>Cash Pickup, Mobile Wallet Top-up and Bill Payments</b><br>Funds will be available or paid to the destination point for all countries to which these services are available within 15 minutes* from the point of payment. In most cases your transfer will be almost instantaneous.</p>
                  <p><b>Bank Transfer</b><br>For the following countries, delivery of funds will be available within 5 minutes: Hong Kong, India, Indonesia, South Korea, Philippines, and Thailand. For other countries it will be within 1 to 2 business days.</p>
                  <p>*Bill Payment to Australia will be within the same business day.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-7">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I add a new recipient on my Wandr-E account?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>To add a recipient to your Wandr-E account:</p>
                  <ol class="faq-content-list">
                    <li class="searchbar-ignore" v-for="item in addRecipientSteps" :key="item.id">
                      {{item}}
                    </li>
                  </ol>
                  <p>Once the recipient has been added successfully, you can either select ‘Send Money’ to start a new fund transfer or select ‘Skip’ to view all the recipients in your account.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-8">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I delete a recipient from my Wandr-E account?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>To delete a recipient from your Wandr-E account:</p>
                  <ol class="faq-content-list">
                    <li class="searchbar-ignore" v-for="item in deleteRecipientSteps" :key="item.id">
                      {{item}}
                    </li>
                  </ol>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-9">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I create a fund transfer on my Wandr-E account?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>A fund transfer can be created using either the 'Send' or 'Quick Send' feature. If you have previously transferred funds using our service, the 'Quick Send' feature will display your top five recipients, along with the most recent transfer details to those recipients.</p>
                  <ol class="faq-content-list">
                    <li class="mt-xl searchbar-ignore" v-for="item in fundTransferSteps" :id="item.id" :key="item.id">
                      <div>{{item.title}}</div>
                      <ol class="faq-content-list" type="i">
                        <li class="searchbar-ignore" v-for="it in item.steps" :key="it">{{it}}</li>
                      </ol>
                    </li>
                  </ol>
                  <p>Once the transfer has been successfully created, complete the payment by following the on-screen payment instructions. Please note that the transfer will only be processed after Wandr-E has confirmed receipt of your payment. You can track the progress of your fund transfer by selecting the 'Activities' option on the main menu.</p>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-10">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">When do I have to pay for my fund transfer?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>It is advised that you pay for your fund transfer as quickly as you can. Please note that if payment is not received by 11 AM on the following day, the fund transfer will be cancelled at 12 PM. If you would like to know when your funds will most likely arrive, you can track its progress via the Wandr-E mobile application or online platform by selecting the fund transfer via the 'Activities' menu.</p></div>
              </li>

              <li class="accordion-item" id="service_payment-11">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What payment options are available for my fund transfer, and how long will it take for my funds to reach Wandr-E's designated customer's bank account?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>The expected time it will take for the funds to be transferred into our bank account using each payment option is displayed in the table below. Please ensure that the name on your bank account matches our records, and the payment amount as well as the settlement reference are correct to avoid delays in payment processing.</p><p>Kindly note that additional documents, such as a bank statement to demonstrate proof of funds, may be required.</p>
                  <table class="faq-table fs-12">
                    <colgroup>
                      <col style="width:28%;">
                      <col style="width:37%; ">
                      <col style="width:35%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th class="label-colum">Type of Payment Methods</th>
                        <th>Transfer Duration</th>
                        <th>Note</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td >Scan & Pay <b><i>[Preferred!]</i></b></td>
                        <td class="text-center">Immediate</td>
                        <td >The settlement number, amount, and payment reference are automatically displayed when the QR code is scanned.</td>
                      </tr>
                      <tr>
                        <td >PAYNOW to UEN <b>200720719MJPM</b></td>
                        <td class="text-center">Immediate</td>
                        <td >Please specify your settlement number as the payment reference.</td>
                      </tr>
                      <tr>
                        <td >Bank Transfer <br><br>(non-DBS banks using FAST service for transfers under SGD200,000)</td>
                        <td class="text-center">Immediate</td>
                        <td >Please specify your settlement number as the payment reference.</td>
                      </tr>
                      <tr>
                        <td >Bank Transfer <br><br>(DBS/POSB)</td>
                        <td >
                            Within 2 hours (for payments between 8am to 8pm only)
                            <br><br>*For payments made between 8pm to 11.59pm, update of receipt of payment will only be reflected in the transaction status after 8am on the next working day.
                            <br><br>*For payments made between 12.00am to 8am, update of receipt of payment will only be reflected in the transaction status after 8am on the same working day.
                        </td>
                        <td >Please specify your settlement number as the payment reference.</td>
                      </tr>
                      <tr>
                        <td >Bank Transfer <br><br>(non-DBS banks using normal service)</td>
                        <td >3 business days</td>
                        <td >Please specify your settlement number as the payment reference.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </li>

              <li class="accordion-item" id="service_payment-12">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How can I track the status of my fund transfer?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>You can track the status of your fund transfer in real time by logging into your Wandr-E account via the mobile application or online platform. Select the specific fund transfer from the 'Activities' menu to view the full transfer details, including its current status.</p></div>
              </li>

              <li class="accordion-item" id="service_payment-13">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I cancel an unsuccessful fund transfer and get a refund?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>To request for a cancellation and refund for an unsuccessful fund transfer, please email our Customer Service Team at <a href="#" @click="followLink('email', 'customerservice@wandr-e.com')">customerservice@wandr-e.com</a> and include your transfer reference number. Please note that we can only process the refund after receiving the returned funds from our agent or correspondent bank. We will also request for the details of your bank account to process the refund.</p></div>
              </li>

              <li class="accordion-item" id="service_payment-14">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How long do refunds take?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>In most cases, the refunded funds will be deposited in your bank account between 1 and 3 business days after we receive the funds from our correspondent bank or agent, provided that the bank account information you submitted is accurate and complete.</p></div>
              </li>

              <li class="accordion-item" id="service_payment-15">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How do I set up FX rate alert notifications?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>To set up FX rate alerts for one or more currencies through the Wandr-E mobile application or online platform:</p>
                  <ol class="faq-content-list">
                    <li class="searchbar-ignore" v-for="item in setFXRateNotifSteps" :key="item.id">{{item}}</li>
                  </ol>
                  <p>Repeat steps 3 through 5 to add a new FX rate alert. You will be notified via email and push notification when the FX rate reaches your target.</p>
                  </div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-fee-charges-fx')}}</div>
              
              <li class="accordion-item" id="fee_charges-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How does Wandr-E's fees compare with a standard telegraphic transfer?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Unlike many banks, which charge a service fee in addition to a percentage fee based on the amount being transferred, Wandr-E transactions are FREE. However, a cost-covering fee may be applied in some cases. There are no additional or hidden fees; all fees will be disclosed upfront.</p></div>
              </li>

              <li class="accordion-item" id="fee_charges-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">When using Wandr-E, are there any fee deductions in the destination country?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Generally, there are no fees involved with processing payments in the destination countries. However, in some countries, banks will charge a fee to deposit money into a customer’s bank account. This may occur in Thailand.</p></div>
              </li>

              <li class="accordion-item" id="fee_charges-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How is transferring funds through Wandr-E different from transferring funds through a bank?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>A bank is a financial institution that provides credit cards, account management, loans, mortgages, bank assurance, and other financial services. Wandr-E, on the other hand, is a licensed specialist in remittance services. Our main area of focus is international payments, and we work hard to deliver top-notch service at prices that are cheaper than those offered by banks while also offering better exchange rates, more delivery options, and faster delivery times. Additionally, Wandr-E's licensing by the relevant authorities ensures the security of your transfers and payments.</p></div>
              </li>

              <li class="accordion-item" id="fee_charges-4">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How does Wandr-E provide exchange rates?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>We strive to consistently provide better exchange rates than local banks. The foreign exchange rates on Wandr-E are based on the global currency markets and are updated every day.<br /><br />To view our exchange rates, visit our website at <a href="#" @click="followLink('mkt')">www.wandr-e.com</a> or log in to your Wandr-E account using the mobile application.</p></div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-coupon-refer-program')}}</div>

              <li class="accordion-item" id="discount_program-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How can I use my discount coupons on the Wandr-E mobile application or online platform?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>If there is a discount coupon available, you can use it when you create a fund transfer. Simply select 'Apply offer code?' and choose the coupon from the list. Some promotional discounts that are published on our social media platforms may require you to manually enter the discount code.<br><br>Go to the 'Coupons' section under the 'Account' menu to view your available coupons.</p></div>
              </li>

              <li class="accordion-item" id="discount_program-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How does Wandr-E's referral program work?</div>
                  </div>
                </a>
                <div class="accordion-item-content">
                  <p>Invite your friends to join Wandr-E and earn rewards by following these steps:</p>
                  <ol class="faq-content-list">
                    <li class="searchbar-ignore" v-for="item in referralSteps" :key="item.id">
                      {{item}}
                    </li>
                  </ol>
                  <p>You will receive a SGD 20 discount voucher in your Wandr-E account for each friend who registers using your invite link and makes a transfer of at least SGD 2,000 within the first 6 months of registering.</p>
                </div>
              </li>


              <div class="wandr-level-2 searchbar-hide-on-search mt-6 mb-3 text-center">{{$t('faq-privacy-security')}}</div>
              <li class="accordion-item" id="app_security-1">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How safe is Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>Wandr-E is a licensed major payment institution in Singapore and adheres to all regulatory requirements set by the Monetary Authority of Singapore (MAS). Wandr-E maintains substantial regulatory deposits and implements safeguarding measures to protect your funds. Wandr-E holds your funds in a designated customer's bank account with a safeguarding institution. <br><br>To protect and maintain the confidentiality of customer information, we place a high priority on safety and security within our business and system. Learn more about our security measures <a href="#" @click="scrollToRef(`app_security-2`)">here</a>.</p></div>
              </li>

              <li class="accordion-item" id="app_security-2">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">How secure is Wandr-E?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>In a word, very.<br><br>All Wandr-E digital channels conform to the same internet standards and regulations that your banks are held to. All digital transactions with Wandr-E are encrypted using 256-bit keys (the same standard adopted by banks and other major Fintech players). All confidential information is stored in an encrypted and secure form within our system, and we never provide any customer information to any third parties (unless legally bound to do so or at your personal request). <br><br>We utilise two factor authentication for both login and for any change to information related to you or your transactional details. <br><br>Our data is hosted in country within highly secure environments run and maintained by best of breed secure hosting providers. <br><br>We are experts in our space, having been in the business for over 20 years and are fully licensed by the regulators in all countries in which we operate which includes the provision of large security deposits. We are periodically audited by these regulators in addition to our own internal and external audit processes. We hold ourselves to the highest standards in terms of regulatory compliance and Anti-Money Laundering standards. <br><br>Finally, our delivery partners are licensed banking partners in their own right in the countries in which they operate, and we maintain our own audit process on all our delivery partners.</p></div>
              </li>

              <li class="accordion-item" id="app_security-3">
                <a href="#" class="item-content item-link">
                  <div class="item-inner">
                    <div class="item-title">What is your privacy policy?</div>
                  </div>
                </a>
                <div class="accordion-item-content"><p>We place great importance on protecting your personal information. Our current <a class="faq-anchor" href="/privacy-policy"><b>Privacy Policy</b></a> and <a class="faq-anchor" href="/terms-and-condition"><b>Terms & Conditions</b></a> provides more details on how we go about doing this. <br><br>Please feel free to email us at <a @click="followLink('email','dpo@wandr-e.com')">dpo@wandr-e.com</a> if you have any specific inquiries concerning your privacy.</p></div>
              </li>
            </ul>
        </div>
    </f7-block>
  </f7-page>
</template>

<script>
  import { mapGetters } from "vuex";
  //import ApiService from '../services/api-main';
  // import { translation } from '@/plugins/i18n'

  export default {
    mounted (){
      var app = this.$f7

      // Required for everypage. Toggle desktop-view footer.
      this.toggleFooterVisibility(false)
      this.$f7.$('.page-content').on('scroll', (e) => {
        this.toggleFooterVisibility(e.target)
      })
      
      // const self = this
      // console.log("get service time json")
      // const data = require('../servicetime.json');
      // this.deliveryTimeList = data;
      // console.log(data);

      // let qr = this.$store.state.customer.qrCode;
      // console.log("CUSTOMER",this.$store.state.customer)
      // self.qrCode = "data:image/png;base64,"+qr
      
      //this.getDeliveryTime();

      app.on('accordionOpened', function (el) {
        const pageDOM = document.querySelector('#faq-page .page-content')
        const adjustment = pageDOM.clientWidth <= 768 || !app.device.desktop ? 118 : 198 ;
        pageDOM.scrollTo({
          top: (el.offsetTop + adjustment),
          behavior: "smooth"
        })
      });

      this.Dom7('.searchbar').on('searchbar:search', function (e) {
          const foundItems = e.detail.foundItems;
          let count = 0;
          foundItems.filter((value) => {
              if(value.classList.contains('accordion-item')){
                count++
              }
          });

          //console.log("count: "+count)
          if(count == 0){
            document.getElementById("searchbar-not-found").style.display = "block";
          }
      });
    },

    data() {
      return {
        deliveryTimeList  : [],
        countryList       : [],
        serviceTypeList   : [],
        country           : "",
        countryId         : 0,
        cutOffTime        : "",
        serviceTime       : "",
        serviceType       : "",
        qrCode            : "",

        registrationSteps:[
          {'id':1,'title':'Register with Singpass MyInfo',
                  'steps':['Select the \'Register\' button.',
                    'Enter your email and create your password.',
                    'Select the \'Register with Singpass\' button.',
                    'Log in to your Singpass account and allow Wandr-E to retrieve your data through Singpass MyInfo.',
                    'Verify the accuracy of the displayed personal information, then select \'Submit\'.',
                    'Enter your mobile number and enter the 6-digit One-Time-Password (OTP) that was sent to your mobile number.',
                    'Review and accept the Terms & Conditions.',
                    'Verify your email address by clicking on the verification link sent to your email account.'],
                  'desc':'You can quickly register for a Wandr-E account and confirm your identity immediately using Singpass MyInfo if all the necessary information is provided. If you do not already have a Singpass account, you can register using one of the alternative methods given below.'},
          {'id':2,'title':'Register manually',
                  'steps':['Select the \'Register\' button.',
                    'Enter your email and create your password.',
                    'Select the \'Register\' button.  ',
                    'Enter your mobile number and enter the 6-digit One-Time-Password (OTP) that was sent to your mobile number.',
                    'Review and accept the Terms & Conditions.',
                    'Verify your email address by clicking on the verification link sent to your email account.']},
          {'id':3,'title':'Register with a Google account',
                  'steps':['Select the \'Register\' button.',
                    'Select the \'Google\' button.',
                    'Enter your Google email account details you would like to register with.',
                    'Create your password.',
                    'Enter your mobile number and enter the 6-digit One-Time-Password (OTP) that was sent to your mobile number.',
                    'Review and accept the Terms & Conditions.',
                    'Verify your email address by clicking on the verification link sent to your email account.']},
          {'id':4,'title':'Register with an Apple ID',
                  'steps':['Select the \'Register\' button.',
                    'Select the \'Apple ID\' button.',
                    'Enter your Apple ID account details you would like to register with.',
                    'Create your password.',
                    'Enter your mobile number and enter the 6-digit One-Time-Password (OTP) that was sent to your mobile number.',
                    'Review and accept the Terms & Conditions.',
                    'Verify your email address by clicking on the verification link sent to your email account.'],
                  'desc':'Once you have completed your registration, you must confirm your identity by uploading your identification documents. If your residential address is not included in your identification document or in Singpass MyInfo, you must provide a separate document to prove your residence. You will be notified when your account has been successfully confirmed.'},
        ],
        loginSteps: [
          {'id':1,'title':'Log in via Singpass (if you have a valid Singpass account)','steps':['Log in to your Singpass account and enter the 6-digit One-Time-Password (OTP) that was sent to your registered mobile number.']},
          {'id':2,'title':'Log in manually','steps':['Enter your email and password.','Enter the 6-digit One-Time-Password (OTP) that was sent to your registered mobile number.']},
          {'id':3,'title':'Log in via your Google account','steps':['Enter your Google account details to proceed with login.']},
          {'id':4,'title':'Log in via your Apple ID','steps':['Enter your Apple ID account details to proceed with login.']}
        ],
        transferCountries: [
          {'title':'Asia: ','content':'Hong Kong, India, Indonesia, Japan, Malaysia, Philippines, South Korea, Sri Lanka, Thailand, Vietnam'},
          //  {'title':'Eurozone:', 'content': 'Austria, Belgium, Croatia, Cyprus, Estonia, Finland, France, Germany, Greece, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, the Netherlands, Portugal, Slovakia, Slovenia, Spain'},
          //  {'title':'North America [USD]:', 'content': 'Canada, Mexico, United States of America'},
          //  {'title':'South America [USD]', 'content':''},
          //{'title':'United Arab Emirates', 'content':''},
          //  {'title':'United Kingdom','content':''},
          {'title':'Oceania: ','content':'Australia, New Zealand'},
          //{'title':'Others [USD]', 'content':''}
        ],
        deliveryMethods: ['Bank Transfer: Your money will be credited to the designated recipient’s bank account.', 'Bill Payment: Your funds will be credited to the designated billing organization.', 'Collection: Wandr-E will arrange for your funds to be available for your recipient to pick up at a branch of the designated banks or agents. Please ensure that your recipient will be able to present a valid form of identification at the time of collection.'],
        addRecipientSteps: ['Select \'Recipients\' from the main menu.','Select \'Add recipient\'.','Select the recipient\'s country from the list.','Select transfer type from the list.','Enter the recipient\'s account details and select \'Add recipient\'.'],
        deleteRecipientSteps: ['Select \'Recipients\' from the main menu.','Select the recipient you wish to delete.','Select \'Delete recipient\'.','When prompted, select \'Delete recipient\' to confirm that your decision to do so.'],
        fundTransferSteps: [
          {'id':1,'title':'\'Send\' feature', 'steps':['Select \'Send\' from the main menu.', 'Select the recipient you wish to send funds to from the list provided or select \'Add recipient\' if the recipient is not already on the list.', 'Enter the amount you wish to send; it can be in SGD or the recipient\'s home currency.', 'Select the purpose of the payment and your preferred payment method from the list. If you have a discount code available, you can apply it here.', 'Select \'Next\'.', 'Review the transaction summary, then select ‘Next’ to confirm the transaction.']},
          {'id':2,'title':'\'Quick Send\' feature', 'steps':['Select your recipient from the \'Quick Send\' list.', 'Review your transfer details or choose to change the amount you wish to send, the purpose of the payment, or your preferred payment method. If you have a discount code available, you can apply it here.', 'Select \'Next\'.', 'Review the transaction summary, then select ‘Next’ to confirm the transaction.']},
        ],
        setFXRateNotifSteps:['Select \'Account\' from the main menu.','Select \'FX Alert\'. ','Select \'Create\'.','Select your preferred currency from the list and enter your target FX rate.','Select \'Create Rate Alert\' to confirm.'],
        referralSteps:['Select \'Invite & Earn\' from the \'Account\' menu.','Share your personal invite link with your friends.'],
      };
    },

    methods: {
      afterin(){
        window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
      },

      getDeliveryTime(){
        const self = this
        self.showPreloader();

        const deliveryTimePromise = self.$api.misc.getServiceTime()
        deliveryTimePromise.then(function(result) {

          self.deliveryTimeList = result.data
          console.log("DELIVERY TIME",self.deliveryTimeList)
        })

        self.hidePreloader();

      },

      goBack() {
        this.$f7router.back({ transition: 'f7-push' });
      },

      scrollToRef(ref){
        var app = this.$f7
        app.accordion.open(document.getElementById(ref))
      },

      followLink(linkType, linkRef){
        if (linkType == 'downloadapp'){
          linkRef = linkRef == 'appstore' ? 'https://apps.apple.com/us/app/wandr-e/id6446774264'
                  : linkRef == 'playstore' ? 'https://play.google.com/store/apps/details?id=com.wandr.app'
                  : this.linkMarketing+'mobileappdownload' ;
        } else if(linkType == 'mkt'){
          linkRef = linkRef ? this.linkMarketing+linkRef : this.linkMarketing ;
        }
        if(linkRef){
          if (window.Android) {
            window.Android.getWandrCallback(JSON.stringify({ "type": 'open_page','data': linkRef}));
          } else if (window.webkit) {
            window.webkit.messageHandlers.WandrCallbackHandler.postMessage(JSON.stringify({ "type": 'open_page', 'data': linkRef}));
          } else {
            let linkToOpen = linkRef
            switch(linkType){
              case 'email': linkToOpen = "mailto:"+linkRef; break;
              default: break;
            }
            window.open(linkToOpen);
          }
        }
      },
    },

    components: {

    },

    computed: {
			...mapGetters('misc', ['linkMarketing'])
    },
  }
</script>
